function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 17.3073C3 7.74877 10.7487 0 20.3073 0H49.6927C59.2512 0 67 7.74875 67 17.3073V46.6927C67 56.2512 59.2512 64 49.6927 64H20.3073C10.7488 64 3 56.2512 3 46.6927V17.3073Z",
  fill: "#1B1B1B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.8402 41.5222C42.7524 41.5484 41.7931 41.8175 41.381 41.9028C39.9151 40.1697 38.0034 38.5428 37.0509 37.0137C36.9428 36.8497 36.8482 36.6791 36.7672 36.5012C36.6118 36.1403 36.524 35.7472 36.524 35.3337C36.524 34.5062 36.8692 33.7588 37.4299 33.2141C37.7805 32.8728 38.2128 32.6162 38.6924 32.4725C38.6992 32.4659 39.3274 32.2881 39.6584 32.1969C39.9151 32.1181 41.3311 31.6673 41.908 31.3962C42.7186 31.015 43.2867 30.5162 43.2867 29.8534C43.2867 28.6466 42.0566 28.5672 41.7931 27.504C41.6445 26.9003 41.3067 26.1462 40.8683 25.6993C40.2056 25.0168 39.1721 24.5509 37.9899 24.4984V21.8019C37.9899 21.8019 30.9981 24.1578 28.6743 34.9334C28.371 36.3634 28.1609 37.7087 28.0332 38.9825C28.0332 39.0022 28.0258 39.0212 28.0258 39.0409C27.1888 47.5859 29.8835 52.7106 30.0388 52.9862V53H26.8638C24.1779 53 22 50.8843 22 48.275V15.7243C22 13.1151 24.1779 11 26.8638 11H37.9426C41.8404 11.1969 45.2451 12.7187 45.3194 12.7587C50.4805 15.3634 54 20.6009 54 26.6384C54 33.6006 49.3125 39.5068 42.8402 41.5222Z",
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.8402 41.5222C42.7524 41.5484 41.7931 41.8175 41.381 41.9028C39.9151 40.1697 38.0034 38.5428 37.0509 37.0137C36.9428 36.8497 36.8482 36.6791 36.7672 36.5012C36.6118 36.1403 36.524 35.7472 36.524 35.3337C36.524 34.5062 36.8692 33.7588 37.4299 33.2141C37.7805 32.8728 38.2128 32.6162 38.6924 32.4725C38.6992 32.4659 39.3274 32.2881 39.6584 32.1969C39.9151 32.1181 41.3311 31.6673 41.908 31.3962C42.7186 31.015 43.2867 30.5162 43.2867 29.8534C43.2867 28.6466 42.0566 28.5672 41.7931 27.504C41.6445 26.9003 41.3067 26.1462 40.8683 25.6993C40.2056 25.0168 39.1721 24.5509 37.9899 24.4984V21.8019C37.9899 21.8019 30.9981 24.1578 28.6743 34.9334C28.371 36.3634 28.1609 37.7087 28.0332 38.9825C28.0332 39.0022 28.0258 39.0212 28.0258 39.0409C27.1888 47.5859 29.8835 52.7106 30.0388 52.9862V53H26.8638C24.1779 53 22 50.8843 22 48.275V15.7243C22 13.1151 24.1779 11 26.8638 11H37.9426C41.8404 11.1969 45.2451 12.7187 45.3194 12.7587C50.4805 15.3634 54 20.6009 54 26.6384C54 33.6006 49.3125 39.5068 42.8402 41.5222Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.3138 31.5297L5.31384 45.5297L6.68616 48.4703L36.6862 34.4703L35.3138 31.5297ZM6.68616 48.4703L36.6862 34.4703L35.3138 31.5297L5.31384 45.5297L6.68616 48.4703ZM35.3138 38.5297L5.31384 52.5297L6.68616 55.4703L36.6862 41.4703L35.3138 38.5297ZM6.68616 55.4703L36.6862 41.4703L35.3138 38.5297L5.31384 52.5297L6.68616 55.4703ZM35.3138 25.5297L5.31384 39.5297L6.68616 42.4703L36.6862 28.4703L35.3138 25.5297ZM6.68616 42.4703L36.6862 28.4703L35.3138 25.5297L5.31384 39.5297L6.68616 42.4703Z",
  fill: "#2E2F30"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.8402 41.5222C42.7524 41.5484 41.7931 41.8175 41.381 41.9028C39.9151 40.1697 38.0034 38.5428 37.0509 37.0137C36.9428 36.8497 36.8482 36.6791 36.7672 36.5012C36.6118 36.1403 36.524 35.7472 36.524 35.3337C36.524 34.5062 36.8692 33.7588 37.4299 33.2141C37.7805 32.8728 38.2128 32.6162 38.6924 32.4725C38.6992 32.4659 39.3274 32.2881 39.6584 32.1969C39.9151 32.1181 41.3311 31.6673 41.908 31.3962C42.7186 31.015 43.2867 30.5162 43.2867 29.8534C43.2867 28.6466 42.0566 28.5672 41.7931 27.504C41.6445 26.9003 41.3067 26.1462 40.8683 25.6993C40.2056 25.0168 39.1721 24.5509 37.9899 24.4984V21.8019C37.9899 21.8019 30.9981 24.1578 28.6743 34.9334C28.371 36.3634 28.1609 37.7087 28.0332 38.9825C28.0332 39.0022 28.0258 39.0212 28.0258 39.0409C27.1888 47.5859 29.8835 52.7106 30.0388 52.9862V53H26.8638C24.1779 53 22 50.8843 22 48.275V15.7243C22 13.1151 24.1779 11 26.8638 11H37.9426C41.8404 11.1969 45.2451 12.7187 45.3194 12.7587C50.4805 15.3634 54 20.6009 54 26.6384C54 33.6006 49.3125 39.5068 42.8402 41.5222Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54 26.5589C54 33.6016 49.4402 39.5763 43.1442 41.615C43.0588 41.6415 42.1256 41.9137 41.7248 42C40.2988 40.2468 38.4391 38.6011 37.5126 37.0543C37.4074 36.8884 37.3154 36.7158 37.2366 36.5359C37.0854 36.1707 37 35.7731 37 35.3549C37 34.7169 37.1971 34.1261 37.5257 33.6421C37.6308 33.4828 37.7491 33.3434 37.8812 33.2106C38.2223 32.8654 38.6428 32.6059 39.1094 32.4605C39.116 32.4538 39.7271 32.2739 40.0491 32.1817C40.2988 32.102 41.6788 31.6433 42.2373 31.3718C42.4871 31.2516 42.7105 31.1189 42.901 30.9728C42.9602 30.9197 43.0193 30.8666 43.0785 30.8208C43.3413 30.5951 43.591 30.3621 43.8276 30.1231C46.1801 27.7399 47.639 24.4545 47.639 20.8226C47.639 17.4309 46.3641 14.3374 44.281 12C45.0571 12.2861 45.5296 12.5052 45.5559 12.5185C50.5763 15.1533 54 20.4515 54 26.5589Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54 26.5589C54 33.6016 49.4402 39.5763 43.1442 41.615C43.0588 41.6415 42.1256 41.9137 41.7248 42C40.2988 40.2468 38.4391 38.6011 37.5126 37.0543C37.4074 36.8884 37.3154 36.7158 37.2366 36.5359C37.0854 36.1707 37 35.7731 37 35.3549C37 34.7169 37.1971 34.1261 37.5257 33.6421C37.6308 33.4828 37.7491 33.3434 37.8812 33.2106C38.2223 32.8654 38.6428 32.6059 39.1094 32.4605C39.116 32.4538 39.7271 32.2739 40.0491 32.1817C40.2988 32.102 41.6788 31.6433 42.2373 31.3718C42.4871 31.2516 42.7105 31.1189 42.901 30.9728C42.9602 30.9197 43.0193 30.8666 43.0785 30.8208C43.3413 30.5951 43.591 30.3621 43.8276 30.1231C46.1801 27.7399 47.639 24.4545 47.639 20.8226C47.639 17.4309 46.3641 14.3374 44.281 12C45.0571 12.2861 45.5296 12.5052 45.5559 12.5185C50.5763 15.1533 54 20.4515 54 26.5589Z",
  fill: "url(#paint1_linear)"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.8402 41.5222C42.7524 41.5484 41.7931 41.8175 41.381 41.9028C39.9151 40.1697 38.0034 38.5428 37.0509 37.0137C36.9428 36.8497 36.8482 36.6791 36.7672 36.5012C36.6118 36.1403 36.524 35.7472 36.524 35.3337C36.524 34.5062 36.8692 33.7588 37.4299 33.2141C37.7805 32.8728 38.2128 32.6162 38.6924 32.4725C38.6992 32.4659 39.3274 32.2881 39.6584 32.1969C39.9151 32.1181 41.3311 31.6673 41.908 31.3962C42.7186 31.015 43.2867 30.5162 43.2867 29.8534C43.2867 28.6466 42.0566 28.5672 41.7931 27.504C41.6445 26.9003 41.3067 26.1462 40.8683 25.6993C40.2056 25.0168 39.1721 24.5509 37.9899 24.4984V21.8019C37.9899 21.8019 30.9981 24.1578 28.6743 34.9334C28.371 36.3634 28.1609 37.7087 28.0332 38.9825C28.0332 39.0022 28.0258 39.0212 28.0258 39.0409C27.1888 47.5859 29.8835 52.7106 30.0388 52.9862V53H26.8638C24.1779 53 22 50.8843 22 48.275V15.7243C22 13.1151 24.1779 11 26.8638 11H37.9426C41.8404 11.1969 45.2451 12.7187 45.3194 12.7587C50.4805 15.3634 54 20.6009 54 26.6384C54 33.6006 49.3125 39.5068 42.8402 41.5222Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M54 26.2838C54 33.452 49.4148 39.5331 43.0837 41.6081C42.9978 41.6351 42.0595 41.9122 41.6564 42C40.8304 40.9723 39.8524 39.973 39 39.0203C39.6211 39.1142 40.2555 39.1622 40.8965 39.1622H40.909C44.5242 39.1622 47.7952 37.6622 50.1674 35.2432C52.4868 32.8642 53.9405 29.6081 53.9934 26C54 26.0946 54 26.1885 54 26.2838Z",
  fill: "black"
}));

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 21.1293,
  y1: 39.9139,
  x2: 49.1705,
  y2: 45.1161,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B9B8C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 45.3061,
  y1: 12.9298,
  x2: 27.1172,
  y2: 19.218,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E3E3E8"
})));

var SvgHitpawToolkitLogo = function SvgHitpawToolkitLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 64,
    viewBox: "0 0 70 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 11,
    width: 32,
    height: 42
  }, _ref4), _ref5, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 11,
    width: 32,
    height: 42
  }, _ref6), _ref7, /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 11,
    width: 32,
    height: 42
  }, _ref8), _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHitpawToolkitLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hitpaw-toolkit-logo.de892e35.svg";
export { ForwardRef as ReactComponent };